/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import LoadingSpinner from '$app/shared/components/LoadingSpinner';
import { api } from '$app/api';
import GarageFocusAllocation from '.';
import { getBookingsToAllocateForGarage } from './apis/bookings';
import useFilters from './hooks/useFilters';

const emptyBookings = { bookingsForGarageAllocate: [] };

const GarageFocusAllocationWrapper = () => {
  const [garages, setGarages] = useState([]);
  const [bookings, setBookings] = useState(emptyBookings);
  const filters = useFilters();
  const { filteredGarage } = filters;

  const getAllGarages = () => api.get(`/garages`);

  useEffect(() => {
    getAllGarages().then(({ data }) => {
      setGarages(data.garages);
    });
  }, []);

  const earliestBookingDate = moment().subtract(60, 'day').startOf('day').format();

  useEffect(() => {
    if (!filteredGarage) {
      setBookings(emptyBookings);
      return undefined;
    }

    let isCancelled = false;
    setBookings(null);

    getBookingsToAllocateForGarage(earliestBookingDate, filteredGarage)
      .then((response) => {
        if (!isCancelled) setBookings(response);
      })
      .catch((error) => {
        console.error(error);
        if (!isCancelled) setBookings(emptyBookings);
      });

    return () => {
      isCancelled = true;
    };
  }, [earliestBookingDate, filteredGarage]);

  if (!garages || !bookings) return <LoadingSpinner />;
  return (
    <GarageFocusAllocation
      garages={garages}
      bookings={bookings}
      earliestBookingDate={earliestBookingDate}
      filters={filters}
    />
  );
};

export default GarageFocusAllocationWrapper;
